const doc = [({"se":({"js":({"routes":({"admin":({"school_class_groups":({"class_steps":({"add_new_class_step":"Lägg till årskurs"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;